<template>
  <div class="login-container">
    <div class="login-header">
      <h1 class="app-title">推广组管理系统</h1>
      <p class="slogan">请登录您的账号</p>
    </div>
    
    <div class="login-form">
      <div class="tabbar">
        <!-- <div :class="index == 0 ? 'active' : ''" @click="index = 0">验证码登录</div> -->
        <div :class="index == 1 ? 'active' : ''" @click="index = 1">密码登录</div>
      </div>
      
      <!-- <div v-if="index == 0">
        <div class="input-group">
          <van-field v-model="phone" type="tel" placeholder="请输入手机号" :border="false" class="custom-input" />
        </div>
        <div class="input-group">
          <van-field v-model="sms" center clearable placeholder="验证码" :border="false" class="custom-input">
            <template #button>
              <van-button size="small" plain type="default" :disabled="times" @click="getsms">{{ times ? number : '获取验证码' }}
              </van-button>
            </template>
          </van-field>
        </div>
        <div class="button-group">
          <van-button type="primary" block size="large" @click="login">登录</van-button>
        </div>
      </div> -->
      
      <div v-if="index == 1">
        <div class="input-group">
          <van-field v-model="te1" type="tel" placeholder="请输入手机号" :border="false" class="custom-input" />
        </div>
        <div class="input-group">
          <van-field v-model="te2" type="password" placeholder="请输入密码" :border="false" class="custom-input" />
        </div>
        <div class="button-group">
          <van-button type="primary" block size="large" @click="login2">登录</van-button>
        </div>
      </div>
    </div>
    
    <van-popup v-model:show="show" :close-on-click-overlay="true" position="center">
      <div class="captcha-popup">
        <h3 class="popup-title">图形验证码</h3>
        <div class="captcha-image-container">
          <img :src="(config!=null ?config.fileServerUrl:'') + captcha.captchaUrl" alt="图形验证码" class="captcha-image" />
        </div>
        <van-field v-model="tutex" type="text" placeholder="请输入图形验证码" :border="false" class="captcha-input" />
        <van-button type="primary" block size="small" @click="getsmstow">确认</van-button>
      </div>
    </van-popup>
    
    <Mask v-if="marke"></Mask>
  </div>
</template>
<script>
import md5 from 'js-md5';
// import { wxqq } from '../utils/utils'
import Mask from '../components/Mask'
import { Toast } from 'vant';

export default {
  name: 'Login',
  data() {
    return {
      show: false,
      phone: '',
      sms: '',
      te1: '',
      te2: '',
      tutex: '',
      config: {
        fileServerUrl: ''
      },
      captcha: {
        captchaId: '',
        captchaUrl: ''
      },
      index: 1,
      times: false,
      marke: false,
      number: 60,
    }
  },
  components: {
    Mask,
  },
  mounted() {
    this.getConfig()
    // this.marke = wxqq()
  },
  methods: {
    getConfig() {
      this.$request.post('/api/base/config').then((res) => {
        if (res.data.code == 0) {
          this.config = res.data.data
          localStorage.setItem('config', JSON.stringify(res.data.data))
        }
      })
    },
    login() {
      let data = {
        phone: this.phone,
        code: this.sms
      }
      this.$request.post('/api/user/passport/loginByPhoneCode', data).then((res) => {
        if (res.data.code == 0) {
          localStorage.setItem('token', res.data.data.token)
          this.$request.postJson('/api/user/pay_group/info', {}).then((res) => {
            if (res.data.code == 0) {
              if (res.data.data) {
                this.$router.push({ path: '/' })
              } else {
                Toast('未查询到推广组信息')
              }
            }
          })
        }
      })
    },
    login2() {
      let data = {
        phone: this.te1,
        password: md5(this.te2)
      }
    
      localStorage.setItem("gphone",data.phone)
      this.$request.post('/api/user/passport/loginByPhoneOfGroup', data).then((res) => {
        if (res.data.code == 0) {
          localStorage.setItem('token', res.data.data.token)
          console.log(res.data.data.isTopLevel)
           localStorage.setItem('isTopLevel', res.data.data.isTopLevel)
          this.$request.postJson('/api/user/pay_group/info', {}).then((res) => {
            if (res.data.code == 0) {
              if (res.data.data) {
                this.$router.push({ path: '/' })
              } else {
                Toast('未查询到推广组信息')
              }
            }
          })
        }
      })
    },
    getsms() {
      if (this.times) return
      let _this = this
      this.$request.post('/api/base/verify', {
        phone: this.phone
      }).then((res) => {
        if (res.data.code == 6) {
          // 图形验证码
          _this.$request.post('/api/base/captcha').then((data) => {
            _this.show = true
            _this.captcha = data.data.data
          })
        } else if (res.data.code == 0) {
          _this.timeNumber()
        }
      })
    },
    getsmstow() {
      let _this = this
      // 带图形验证码获取验证码
      this.$request.post('/api/base/verify', {
        phone: this.phone,
        captchaId: this.captcha.captchaId,
        captchaCode: this.tutex
      }).then((res) => {
        if (res.data.code === 0) {
          _this.show = false
          _this.timeNumber()
        }
      })
    },
    timeNumber() {
      this.times = true
      this.number = 60
      let timer = setInterval(() => {
        this.number -= 1
        if (this.number <= 0) {
          clearInterval(timer)
          this.times = false
        }
      }, 1000)
    }
  }
}
</script>
<style lang="less" scoped>
/* 全局样式重置 */
* {
  box-sizing: border-box;
}

/* 登录页面容器 */
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  display: flex;
  flex-direction: column;
  padding: 20px;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

/* 头部标题 */
.login-header {
  text-align: center;
  margin-top: 60px;
  margin-bottom: 40px;
}

.app-title {
  font-size: 28px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 10px 0;
  background: none;
  -webkit-background-clip: none;
  -webkit-text-fill-color: #ffffff;
  background-clip: none;
}

.slogan {
  font-size: 16px;
  color: #888888;
  text-align: center;
  margin: 0;
  opacity: 0.9;
}

/* 登录表单容器 */
.login-form {
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  background: #2a2a2a;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid #3a3a3a;
}

/* 标签栏 */
.tabbar {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-bottom: 30px;
  display: flex;
  border-bottom: 1px solid #f0f0f0;

  div {
    width: 50%;
    height: 100%;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    color: #888888;
  }

  div:hover {
    color: #4CAF50;
  }

  .active {
    color: #ffffff;
    font-weight: 600;
  }

  .active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #4CAF50 0%, #66BB6A 100%);
    border-radius: 3px;
  }
}

/* 输入组 */
.input-group {
  margin-bottom: 20px;
  border: 1px solid #4a4a4a;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  background-color: #3a3a3a;
}

.input-group:focus-within {
  border-color: #666666;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: #3a3a3a;
}

/* 自定义输入框 */
.custom-input {
  height: 52px;
  font-size: 15px;
  background-color: transparent;
  color: #ffffff;
  
  &:focus {
    border-color: #666666;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.3);
  }
}

:deep(.van-field__input) {
  color: #ffffff !important;
  font-size: 15px;
  background: #3a3a3a;
}

:deep(.van-field__control) {
  color: #ffffff !important;
}

:deep(.van-field__placeholder) {
  color: #666666;
}

/* 按钮组 */
.button-group {
  margin-top: 40px;
}

/* 自定义按钮样式 */
:deep(.van-button--primary) {
  background: linear-gradient(135deg, #3a3a3a 0%, #4a4a4a 100%);
  color: #ffffff;
  border: none;
  height: 50px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 25px;
  transition: all 0.3s ease;
}

:deep(.van-button--primary:hover:not(:disabled)) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  filter: brightness(1.05);
}

:deep(.van-button--primary:active:not(:disabled)) {
  transform: translateY(0);
  filter: brightness(0.95);
}

/* 验证码输入框深度样式 */
:deep(.captcha-input .van-field__input) {
  color: #ffffff !important;
}

:deep(.captcha-input .van-field__placeholder) {
  color: #666666 !important;
}

/* 验证码弹窗 */
.captcha-popup {
  width: 320px;
  padding: 24px;
  background: #2a2a2a;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: 1px solid #3a3a3a;
}

.popup-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 20px 0;
}

.captcha-image-container {
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 8px;
  background-color: #3a3a3a;
  display: inline-block;
  border: 1px solid #4a4a4a;
}

.captcha-image {
  width: 180px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
}

.captcha-input {
  margin-bottom: 20px;
  border: 1px solid #4a4a4a;
  border-radius: 8px;
  height: 44px;
  background-color: #3a3a3a;
  color: #ffffff;
  
  &:focus-within {
    border-color: #666666;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.3);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-form {
    padding: 24px;
  }
  
  .app-title {
    font-size: 24px;
  }
  
  .login-header {
    margin-top: 40px;
    margin-bottom: 30px;
  }
  
  .captcha-popup {
    width: 90vw;
    max-width: 300px;
    padding: 20px;
  }
  
  .captcha-image {
    width: 150px;
    height: 50px;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 16px;
  }
  
  .login-form {
    padding: 20px;
  }
  
  .app-title {
    font-size: 22px;
  }
  
  .slogan {
    font-size: 14px;
  }
}
</style>
